module.exports = __webpack_public_path__ + "static/media/image-4.2185f427.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/SEOin2020/image-4.png
// module id = 466
// module chunks = 0